// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"871ed923","732":"b9378afb","977":"a5ebcacc"}[chunkId] + ".chunk.js");